/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Discord_TitleInputs */

const en_gd_discord_title = /** @type {(inputs: Gd_Discord_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to ask around first?`)
};

const id_gd_discord_title = /** @type {(inputs: Gd_Discord_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ada yang mau ditanyakan lebih dulu?`)
};

/**
* | output |
* | --- |
* | "Want to ask around first?" |
*
* @param {Gd_Discord_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_discord_title = /** @type {((inputs?: Gd_Discord_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Discord_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_discord_title(inputs)
	return en_gd_discord_title(inputs)
});